import { TopicTranslation } from "../types/queries";

export const normalizeConversationTitle = (topic?: string | null) => {
  const title = topic?.trim() ?? "";
  return title || undefined;
};

const languageCode = (language: string) => language.toLowerCase().split("-")[0];

export const topicNameForLanguage = (
  translations: TopicTranslation[],
  language: string,
) => {
  const requested = languageCode(language);
  const translation =
    translations.find(
      (item) => languageCode(item.languageCode) === requested,
    ) ??
    translations.find((item) => languageCode(item.languageCode) === "fi") ??
    translations[0];
  return normalizeConversationTitle(translation?.name);
};

/**
 * A configured topic is shown by id from the topic list.
 * An unknown id is hidden. Legacy conversations keep the free-text topic.
 */
export const resolveConversationTitle = ({
  topic,
  topicId,
  topicsById,
  language,
}: {
  topic?: string | null;
  topicId?: string | null;
  topicsById: Record<string, { translations?: TopicTranslation[] }>;
  language: string;
}) => {
  const id = topicId?.trim();
  if (id) {
    return topicNameForLanguage(topicsById[id]?.translations ?? [], language);
  }
  return normalizeConversationTitle(topic);
};

/** The title locks once a message has been sent and cannot be changed after that. */
export const isConversationTitleLocked = (hasSentMessage: boolean) =>
  hasSentMessage;

export const shouldShowConversationTitle = ({
  title,
  locked,
  editingEnabled,
}: {
  title?: string;
  locked: boolean;
  editingEnabled: boolean;
}) => Boolean(title) || (editingEnabled && !locked);
